import { render, staticRenderFns } from "./FactoryEdit.vue?vue&type=template&id=09c408c3"
import script from "./FactoryEdit.vue?vue&type=script&lang=js"
export * from "./FactoryEdit.vue?vue&type=script&lang=js"
import style0 from "./FactoryEdit.vue?vue&type=style&index=0&id=09c408c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports